import React from 'react';
import { useDispatch } from 'react-redux';
import { getCommonConnectorsFeatureData } from 'js/actions/paging';
import { useOnGrowthBookReady } from 'new/hooks/useOnGrowthBookReady';

/**
 * Handler to update common connectors when GrowthBook is ready
 * This ensures feature flags are properly evaluated after GrowthBook loads.
 *
 * Note: This updates common connectors from feature flags if available.
 * If no feature flag data exists, it maintains whatever was loaded from API.
 */
const GrowthBookReadyHandler: React.FC = () => {
  const dispatch = useDispatch<any>();

  useOnGrowthBookReady(() => {
    // Update common connectors once GrowthBook is ready
    // Feature flags can now be properly evaluated
    // This will only update if feature flag has data
    dispatch(getCommonConnectorsFeatureData());
  }, [dispatch]);

  return null;
};

export default GrowthBookReadyHandler;
